// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"youtube_tooltip__30vI8"};